module.exports = __webpack_public_path__ + "img/binarystar-brand-logo-no-text.6f49bc00.svg";